export default __webpack_public_path__ + "static/a96d5f9bda19e13a9e2d677f4692e966.png";